module.exports = __webpack_public_path__ + "static/media/envelope-open-dollar.d2cfb2fd.svg";